export const SELECTION_KEY = 'update-users-entitlements';

export {
    NO_ASSIGNED_ENTITLEMENT_TITLE,
    NO_ASSIGNED_ENTITLEMENT_DESCRIPTION,
} from 'src/modules/entitlements/constants';
